/* eslint-disable no-underscore-dangle */

/**
 * satelliteTrack function to track satellite events on omniture
 * @param events Event id to track
 */
function satelliteTrack(events) {
  try {
    window._satellite.track(events);
  } catch {
    // Do nothing
  }
}

module.exports = satelliteTrack;
